export enum RemoteConfigKeys {
    SHOW_ADD_HOST_KEY = 'show_add_host',
    SHOW_TYPES_KEY = 'show_types',
    CTA_FONT_COLOUR_KEY = 'CTA_font_colour',
    CTA_BUTTON_COLOUR_KEY = 'CTA_button_colour',
    API_KEY = 'api',
    TERMS_AND_CONDITIONS_KEY = 'terms_and_conditions',
    ADD_HOST_KEY = 'add_host',
    SHOW_CHAT_KEY = 'show_chat',
    APPLE_LOGIN_KEY = 'apple_login',
    FB_LOGIN_KEY = 'fb_login',
    GOOGLE_LOGIN_KEY = 'google_login',
    FORCE_UPDATE_KEY = 'force_update',
    DEFAULT_LOCATION_KEY = 'default_location',
    DEFAULT_CURRENCY_KEY = 'default_currency',
    CANCELLATION_POLICY_KEY = 'cancellation_policy',
    DEFAULT_CANCELLATION_PERIOD_KEY = 'default_cancellation_period',
    DEFAULT_CANCELLATION_FROM_KEY = 'default_cancellation_from',
    INCORPORATION_TEXT_KEY = 'default_incorporation_text',
    SHOW_WORKSPACE_PROMO_KEY = 'show_workspace_promo',
    SHOW_LISTING_PROMO_KEY = 'show_listing_promo',
    WORKSPACE_PROMO_TEXT_KEY = 'workspace_promo_text',
    LISTING_PROMO_TEXT_KEY = 'listing_promo_text',
    LISTING_PROMO_COLOR_KEY = 'listing_promo_color',
    WORKSPACE_PROMO_COLOR_KEY = 'workspace_promo_color',
    LISTING_PROMO_TEXT_COLOR_KEY = 'listing_promo_text_color',
    WORKSPACE_PROMO_TEXT_COLOR_KEY = 'workspace_promo_text_color',
    HELP_CENTER_KEY = 'help_center',
    DEEP_LINKING_PREFIX_KEY = 'deep_link_prefix',
    CAPTURE_GOOGLE_PHONE_SSO_KEY = 'capture_phone_google_sso',
    SUPPORT_ENGINE_KEY = 'support_engine',
    ZENDESK_ACCOUNT_KEY = 'zendesk_account_key',
    ZENDESK_APP_ID_KEY = 'zendesk_app_id',
    INTERCOM_IOS_KEY = 'intercom_ios_key',
    INTERCOM_ANDROID_KEY = 'intercom_android_key',
    INTERCOM_APP_ID_KEY = 'intercom_app_id',
    SEND_FEEDBACK_KEY = 'send_feedback',
    REPORT_BUG_KEY = 'report_bug',
    SEARCH_RADIUS_KEY = 'search_radius',
    ALLOW_MAP_GESTURES = 'allow_map_gestures',
    CAMERA_ZOOM_KEY = 'camera_zoom',
    SHOW_INCORPORATION_KEY = 'show_incorporation',
    SHOW_EJARI_KEY = 'show_ejari',
    SHOW_VIRTUZONE_KEY = 'show_virtuzone',
    INCORPORATION_BOOKING_TEXT_KEY = 'incorporation_booking_text',
    EJARI_AMENITY_ID_KEY = 'ejari_amenity_id',
    DESK_TYPE_ID_KEY = 'desk_type_id',
    DYNAMIC_LINK_DEFAULT_TEXT_KEY = 'workspace_listing_share_default_text',
    BOOKING_SHARE_DEFAULT_TEXT_KEY = 'booking_share_default_text',
    INDEX_PAGE_INCORPORATION_HEADER_KEY = 'index_page_incorporation_header',
    INDEX_PAGE_EJARI_HEADER_KEY = 'index_page_ejari_header',
    INDEX_PAGE_HOST_HEADER_KEY = 'index_page_host_header',
    GOOGLE_API_REMOTE_KEY = 'google_api_key',
    SMARTLOOK_API_REMOTE_KEY = 'smartlook_api_key',
    MIXPANEL_TOKEN_KEY = 'mixpanel_token',
    ADJUST_TOKEN_KEY = 'adjust_token',
    FIREBASE_ANALYTICS_ENABLE_KEY = 'firebase_analytics_enable',
    ADJUST_ANALYTICS_ENABLE_KEY = 'adjust_analytics_enable',
    // MIXPANEL_ANALYTICS_ENABLE_KEY = "mixpanel_analytics_enable",
    SHOW_REFERRAL_KEY = 'show_referral',
    REFERRAL_TEXT_KEY = 'referral_text',
    REFERRAL_SHARE_TEXT_KEY = 'referral_share_text',
    SHOW_WALLET_KEY = 'show_wallet',
    LINKEDIN_CLIENT_ID_KEY = 'linkedin_client_id',
    LINKEDIN_SECRET_KEY = 'linkedin_secret',
    LINKEDIN_REDIRECT_URL_KEY = 'linkedin_redirect',
    LINKEDIN_LOGIN_KEY = 'linkedin_login',
    LINKEDIN_ACCESS_SCOPE_KEY = 'linkedin_scope',
    HOME_PAGE_MAIN_BANNER_KEY = 'main_banner',
    HOME_PAGE_INCORPORATION_BANNER_KEY = 'incorporation_banner',
    HOME_PAGE_BECOME_A_HOST_BANNER_KEY = 'become_a_host_banner',
    HOME_PAGE_EJARI_BANNER_KEY = 'ejari_banner',
    CONFIRM_BOOKING_GIF_KEY = 'confirm_booking_gif',
    HOME_PAGE_MAIN_BANNER_TITLE_KEY = 'main_banner_title',
    HOME_PAGE_MAIN_BANNER_SUBTITLE_KEY = 'main_banner_subtitle',
    HOME_PAGE_MAIN_BANNER_TITLE_COLOR_KEY = 'main_banner_title_color',
    HOME_PAGE_MAIN_BANNER_SUBTITLE_COLOR_KEY = 'main_banner_subtitle_color',
    HOME_PAGE_MAIN_BANNER_ICON_KEY = 'main_banner_murphy',
    USER_MURPHY_ICON_KEY = 'user_murphy_icon',
    HOME_PAGE_DISCOVER_IMAGE_KEY = 'discover_image',
    HOME_PAGE_EXPLORE_NEAR_BY_TITLE_KEY = 'index_page_nearby_header',
    HOME_PAGE_TYPES_TITLE_KEY = 'index_page_types_header',
    HOME_PAGE_DESK_IMAGE_KEY = 'types_desk_image',
    HOME_PAGE_OFFICE_IMAGE_KEY = 'types_office_image',
    HOME_PAGE_MEETING_ROOM_IMAGE_KEY = 'types_meeting_room_image',
    REFERRAL_IMAGE_KEY = 'referral_image',
    NO_BOOKING_IMAGE_KEY = 'no_booking_image',
    SHOW_VAT_KEY = 'show_VAT',
    VAT_TEXT_KEY = 'VAT_text',
    VAT_VALUE_KEY = 'vat_value',
    FIRST_OPEN_KEY = 'first_open',
    SESSION_START_KEY = 'session_start',
    SIGNUP_KEY = 'signup',
    FIRST_BOOKING_REQUESTED_KEY = 'first_booking_requested',
    WORKSPACE_LISTING_PAGINATION_LIMIT_KEY = 'workspace_listing_pagination_limit',
    LISTING_PAGINATION_LIMIT_KEY = 'listing_pagination_limit',
    AMENITIES_LIST_LIMIT_KEY = 'amenities_list_limit_key',
    HD_LISTING_AMENITIES_KEY = 'hd_listing_amenities',
    HD_WORKSPACE_AMENITIES = 'hd_workspace_amenities',
    FB_ADVERTISING_TRACKING_ENABLED_KEY = 'fb_advertising_tracking_enabled',
    MESSAGES_PAGINATION_LIMIT_KEY = 'messages_pagination_limit_key',
    EXPERIMENT_SHOW_MANAGE_BOOKINGS_KEY = 'experiment_show_manage_bookings',
    POSITIVE_BUTTON_COLOR_KEY = 'positive_button_color',
    POSITIVE_FONT_COLOR_KEY = 'positive_font_colour',
    NEGATIVE_BUTTON_COLOR_KEY = 'negative_button_colour',
    NEGATIVE_FONT_COLOR_KEY = 'negative_font_colour',
    IUBENDA_CONFIG_JSON_URL_KEY = 'iubenda_config_json_url',
    IUBENDA_CUSTOM_STYLE_CSS_URL_KEY = 'iubenda_custom_style_css_url',
    IUBENDA_SITE_ID_KEY = 'iubenda_site_id',
    IUBENDA_COOKIE_POLICY_ID_KEY = 'iubenda_cookie_policy_id',
    IUBENDA_PUBLIC_API_KEY = 'iubenda_public_api_key',
    IUBENDA_CONSENT_LINK_KEY = 'iubenda_consent_link',
    GDPR_ENABLED_KEY = 'gdpr_enabled',
    GDPR_LANGUAGE_KEY = 'gdpr_language',
    EXPERIMENT_MAGIC_LINK_KEY = 'experiment_magic_link_enabled',

    SAME_DAY_BOOKING_HOURLY_KEY = 'same_day_booking_hourly',
    SAME_DAY_BOOKING_MONTHLY_KEY = 'same_day_booking_monthly',
    SAME_DAY_BOOKING_DAILY_KEY = 'same_day_booking_daily',
    SAME_DAY_BOOKING_ANNUAL_KEY = 'same_day_booking_annual',
    PRIVACY_KEY = 'privacy',
    HOST_LANDING_TEST_KEY = 'host_landing_text',

    HD_SUBSCRIPTION_API_KEY = 'hd_subscribe_api_key',
    HD_LANDING_PAGE_API_KEY = 'hd_landing_page_api_key',

    HD_SIDENAV_DASHBOARD = 'hd_ui_sidenav_dashboard',
    HD_SIDENAV_USERS = 'hd_ui_sidenav_users',
    HD_SIDENAV_EARNING = 'hd_ui_sidenav_earnings',
    HD_SIDENAV_ANALYTICS = 'hd_ui_sidenav_analytics',
    HD_SIDENAV_BOOKINGS = 'hd_ui_sidenav_bookings',
    HD_SIDENAV_SPACES = 'hd_ui_sidenav_spaces',
    HD_SIDENAV_MYPROFILE = 'hd_ui_sidenav_myprofile',
    HD_SIDENAV_SETTINGS = 'hd_ui_sidenav_settings',
    HD_SIDENAV_LOCATION = 'hd_ui_sidenav_location',
    HD_FLUSH_TIMEOUT = 'flush_bar_verify_timeout',
    HD_GUIDE_ADD_WORKSPACE_INFO_KEY = 'hd_guide_add_workspace_info',
    HD_GUIDE_ADD_WORKSPACE_AMENITIES_KEY = 'hd_guide_add_workspace_amenities',
    HD_GUIDE_ADD_WORKSPACE_HOURS_KEY = 'hd_guide_add_workspace_hours',

    HD_LISTING_ITEM_PER_PAGE = 'hd_listing_item_per_page',

    HD_DELETE_WORKSPACE_FUNCTIONALITY = 'hd_delete_workspace_functionality',
    HD_ENABLE_WORKSPACE_FUNCTIONALITY = 'hd_enable_workspace_functionality',
    HD_DISABLE_LISTING_FUNCTIONALITY = 'hd_disable_listing_functionality',
    HD_ENABLE_LISTING_FUNCTIONALITY = 'hd_enable_listing_functionality',
    HD_DELETE_LISTING_FUNCTIONALITY = 'hd_delete_listing_functionality',

    HD_LISTING_PAYMENT_METHODS = 'hd_listing_payment_methods',
    HD_LISTING_PLANS = 'hd_listing_plans',
    HD_PAYMENT_TERM_KEY = 'payment_terms',

    HD_UI_DASHBOARD_COMING_SOON = 'hd_ui_dashboard_coming_soon',
    ADD_COMPANY_GUIDE = 'add_company_guide',
    COMPANY_NAME_LIMIT = 'company_name_limit',
    LOGO_SIZE = 'logo_size',
    NUMBER_WORKSPACES_LIMIT = 'num_workspaces_limit',
    // Character list for validation
    NAME_CHAR_LIMIT_KEY = 'name_char_limit',
    WORKSPACE_NAME_CHAR_LIMIT_KEY = 'workspace_name_char_limit',
    LISTING_NAME_CHAR_LIMIT_KEY = 'listing_name_char_limit',
    POSTAL_CODE_CHAR_LIMIT_KEY = 'postal_code_char_limit',
    STREET_CHAR_LIMIT_KEY = 'street_char_limit',
    BUILDING_CHAR_LIMIT_KEY = 'building_char_limit',
    AREA_CHAR_LIMIT_KEY = 'area_char_limit',
    DIRECTIONS_CHAR_LIMIT_KEY = 'directions_char_limit',
    WORKSPACE_DESCRIPTION_LIMIT_KEY = 'workspace_description_limit',
    LISTING_DESCRIPTION_LIMIT_KEY = 'listing_description_limit',
    CHECKIN_INSTRUCTIONS_LIMIT_KEY = 'checkin_instructions_limit',
    LISTING_PRICE_LIMIT_KEY = 'listing_price_limit',
    SALES_CALENDLY = 'webv2_calendly_form',
    APP_CTA_CONTENT = 'book_cta_content',
    SETUPTEAMCONTENT = 'setup_team_content',
    QR_LINK = 'qr_dynamic_link',
    HELPCENTER = 'help_center',
    EMIRATES_CTA = 'emirates_cta',
    UAE_VZ_CTA = 'uae_vz_cta',
    APP_SECTION_TITLE = 'app_section_title',
    DESK_TYPE_ANIMATION = 'desk_type_animation',
    NUMBER_OF_HOSTS = 'number_of_hosts',
    BRANDSLOGO = 'brands_logos',
    WEB_APP_DRAWER = 'web_app_drawer',
    HD_TEST_API_URL_KEY = 'test_api_url',
    HD_TEST_API_ENABLE_KEY = 'test_api_enable',
    ACTIVE_COUNTRY_LIST = 'active_country_list',
    CALC_TALK_EXPERT = 'calc_talk_to_expert',
    ENTRY_POINTS_SWITCH = 'entry_points_switch',
    REQUEST_VIEWING_TITLE = 'request_viewing_title',
    HD_LISTING_TYPES_KEY = 'hd_listing_types',
    default_currency = 'default_currency',
    DEEP_LINK_PREFIX = 'deep_link_prefix',
    HD_DYNAMIC_LINK_API = 'hd_dynamic_link_api_key',
    MAP_SCEEN_LANDING = 'map_screen_landing',
    LISTING_PAGINATION_LIMIT = 'listing_pagination_limit',
    DEFAULT_LOCATION = 'default_location',
    SEARCH_RADIUS = 'search_radius',
    WEB_DIRECTORY_HEADER = 'web_directory_header',
    REQUEST_VIEWING_DETAILS_CHAR_LIMIT = 'request_viewing_details_char_limit',
    REQUEST_VIEWING_COMPANY_NAME_CHAR_LIMIT = 'request_viewing_company_name_char_limit',
    REQUEST_VIEWING_NAME_CHAR_LIMIT = 'request_viewing_name_char_limit',
    REQUEST_VIEWING_EMAIL_CHAR_LIMIT = 'request_viewing_email_char_limit',
    BOOKING_SHARE_DEFAULT_TEXT = 'booking_share_default_text',
    APP_REVIEWS_FEARURE_SWITCH = 'app_reviews_feature_switch',
    APP_REVIEWS_CATEGORIES_FLAG = 'app_reviews_categories_flag',
    /** Master kill-switch for web reviews (add + display). */
    WEB_REVIEWS_FEATURE_SWITCH = 'web_reviews_feature_switch',
    /** Show Rate experience / add-review entry on post-booking screens. Default false. */
    WEB_REVIEWS_ADD = 'web_reviews_add',
    /** Max characters for review text. Default 120. */
    WEB_REVIEWS_TEXT_BOX_LIMIT = 'web_reviews_text_box_limit',
    /**
     * JSON: which workspace surfaces show ratings.
     * Keys: web_reviews_workspace_explore | home | details | booking_details | booking_review
     */
    WEB_REVIEWS_WORKSPACE_SCREENS_SWITCH = 'web_reviews_workspace_screens_switch',
    /**
     * JSON: which listing surfaces show ratings.
     * Keys: web_reviews_listing_explore | home | details | workspace | booking_details | booking_review
     */
    WEB_REVIEWS_LISTING_SCREENS_SWITCH = 'web_reviews_listing_screens_switch',
    /** Pagination / initial visible count for review lists. Default 1. */
    WEB_REVIEWS_PAGINATION_LIMIT = 'web_reviews_pagination_limit',
    APP_SAME_PEICE_TITLE = 'app_same_price_title',
    APP_SAME_PRICE_ICON = 'app_same_price_icon',
    SUBSCRIPTION_LABEL = 'subscription_label',
    /** Kill-switch for listing-level membership offer (checkout upsell, labels, etc.) */
    SUBSCRIPTION_LISTING_OFFER_TOGGLE = 'subscription_listing_offer_toggle',
    SUBSCRIPTION_LISTING_OFFER_LISTINGS = 'subscription_listing_offer_listings',
    WEB_DIRECTORY_POP_UP_FLAG = 'Web_directory_pop_up_flag',
    WEB_DIRECTORY_POP_UP_COUNT = 'Web_directory_pop_up_count_down',
    WEB_DIRECTORY_IMAGE_SIZE_EXPLORE = 'web_directory_image_size_explore',
    WEB_DIRECTORY_IMAGE_SIZE_DETAILS = 'web_directory_image_size_detail',
    LS_RECEPTIONS_HOURS_ALERT = 'ls_reception_hours_alert',
    WS_RECEPTION_HOURS_ALERT = 'ws_reception_hours_alert',
    WEB_WHATSAPP_LINK = 'web_whatsapp_link',
    WEB_PEAPLE_FILTER_MAX = 'people_filter_max',
    WEB_PEAPLE_FILTER_MIN = 'People_filter_min',
    WEB_AMINITIES_ALL_ORDER = 'amenities_all_order',
    WEB_AMINITIES_SHORT_ORDER = 'amenities_short_order',
    WEB_LISTING_TYPE_FILTER = 'listing_type_filter',
    WEB_MONTH_FILTER_PRICE_MIN = 'month_filter_price_min',
    WEB_MONTH_FILTER_PRICE_MAX = 'month_filter_price_max',
    WEB_HOUR_FILTER_PRICE_MIN = 'hour_filter_price_min',
    WEB_HOUR_FILTER_PRICE_MAX = 'hour_filter_price_max',
    WEB_DAY_FILTER_PRICE_MIN = 'day_filter_price_min',
    WEB_DAY_FILTER_PRICE_MAX = 'day_filter_price_max',
    WEB_ANNUAL_FILTER_PRICE_MIN = 'annual_filter_price_min',
    WEB_ANNUAL_FILTER_PRICE_MAX = 'annual_filter_price_max',
    WEB_FILTERS_SWITCH = 'web_filters_switch',
    WEB_AUTH_SWITCH = 'web_auth_switch',
    WEB_SHOW_FORGET_PASSWORD = 'show_forgot_password',
    WEB_CAPTURE_PHONE_SSO = 'capture_phone_sso',
    WEB_CHATWOOT_SWITCH = 'web_chatwoot_switch',
    WEB_CANCELLATION_REASONS = 'cancellation_reasons',
    WEB_SUBSCRIPTION_OFFERINGS_WEB_PAGE = 'subscription_offerings_web_page',
    WEB_SUBSCRIPTION_OFFERING_WEB_PAGE_SWITCH = 'subscription_offering_web_page_switch',
    WEB_LINKED_ACCOUNTS_TAB = 'linked_accounts_tab',
    WEB_LINKED_ACCOUNTS_ITIDA_TEXT_FIELD = 'itida_text_field',
    WEB_SUBSCRIPTION_OFFERINGS_WEB_PAGE_ITIDA_GROUP = 'subscription_offerings_web_page_itida_group',
    WEB_SUBSCRIPTION_OFFERINGS_WEB_PAGE_ITIDA_SUBSCRIPTION = 'subscription_offerings_web_page_itida_subscription',
    WEB_SUBSCRIPTION_OFFERINGS_WEB_PAGE_ITIDA = 'subscription_offerings_web_page_itida',
    WEB_LINKED_ACCOUNTS_APPLE_PAY = 'apple_pay',
    WEB_LINKED_ACCOUNTS_GOOGLE_PAY = 'google_pay',
    WEB_APPLE_PAY_SUBSCRIPTIONS = 'apple_pay_subscriptions',
    WEB_GOOGLE_PAY_SUBSCRIPTIONS = 'google_pay_subscriptions',
    WEB_BLOG_ROUTE = 'web_blog_route',
    ALLOW_POSTHOG = 'tracking_feature',
    ALLOW_POSTHOG_QA = 'tracking_feature_QA',
    WEB_HOME_HERO_IMAGES = 'web_home_hero_images',
    WEB_LANDING_FALLBACK_CAROUSELS = 'web_landing_fallback_carousels',
    WEB_SHOW_WHATSAPP_BUTTON = 'web_show_whatsapp_button',
    MEMBERSHIP_PASS_DISCOUNT_VALUE = 'membership_pass_discount_value',
    IWG_MEETING_ROOM_PRODUCT_TYPE_ID = 'iwg_meeting_room_product_type_id',
    WEB_IWG_SERVICES_AMENDMENT = 'web_iwg_services_amendment',
    WEB_IWG_SERVICES_PICKER = 'web_iwg_services_picker',
    MY_PLANS_WEB_SWITCH = 'My_plans_web_switch',
    // company_setup group — shows the company setup page and its
    // "For Businesses" dropdown entry
    COMPANY_SETUP_SWITCH = 'company_setup_switch',
    /** JSON `CompanySetupCountry[]` — countries listed in the pop-up. */
    COMPANY_SETUP_COUNTRIES = 'company_setup_countries',
    /**
     * Prefix of the per-country, per-locale content JSON keys:
     * `company_setup_content_{country}_{locale}`, e.g. `..._ae_en`.
     */
    COMPANY_SETUP_CONTENT_PREFIX = 'company_setup_content_',
    /** Country → package IDs + pass discount for booking-checkout membership upsell */
    WEB_CHECKOUT_UPGRADE_POPUP = 'web_checkout_upgrade_popup',
    // web_search_bar group — ISO-2 country code → top cities shown in the
    // landing search bar's empty-state panel
    SUGGESTED_DESTINATIONS = 'suggested_destinations',
    /** Fallback: the whole `web_search_bar` group as one JSON parameter. */
    WEB_SEARCH_BAR = 'web_search_bar'
}

export type RemoteConfigeValueType = string | boolean | number | object;
